import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  tutorial: !!localStorage.getItem('tutorial'),
  currentModal: false,
  activeAside: false,
  rawStudy: null,
  study: null,
  studies: [],
  studyLoaded: false,
  activeIndex: -1,
  ruleFilters: {},
  filters: {},
  isochrone: null,
  isochronePrivate: null,
  isochronePublic: null,
  isochroneMode: 'public',
  isochroneDecay: 1,
  isochroneDisplay: true,
  publicTransportLinesShown: false,
  airQualityIndexOverlayShown: false,
  globalFilters: {
    collaborators: true,
    targetSites: [],
    currentMatchingTime: 'public',
  },

  poiVisibility: {
    supermarket: true,
    restaurant: true,
    gym: true,
    school: true,
  },

  isFetching: false,
  collaborators: [],
  isDuplicating: false,
};

export default {
  state,
  getters,
  actions,
  mutations,
};
